// extracted by mini-css-extract-plugin
export default {"block":"BlockFIle_block__wTsdn","text":"BlockFIle_text__QQKhz","icon":"BlockFIle_icon__G51Hw"};